import React, { useState } from "react";
import { TableContext } from "../../index";
import { debug } from "../../utils";
import { useHistory } from "react-router-dom";
import RetentionSection from "./RetentionSection";
import IdleTimeoutSection from "./IdleTimeoutSection";
import ComplianceTargetSection from "./ComplianceTargetSection";
// import AdditionalSSHAlgorithmOptionsSection from "../additionalSSHAlgorithm/AdditionalSSHAlgorithmOptionsSection";
import ValidationResultSection from "./ValidationResultSection";
import BackupFilesSection from "./BackupFilesSection";
// import FetchDeviceConfigCommandSection from "./FetchDeviceConfigCommandSection";
import DomainSection from "./DomainSection";
import MLConfigsSection from "./MLConfigsSection";
// import MachineLearningSection from "./MachineLearningSection";
// import RemoteSyslogServerSection from "../remote-syslogserver/RemoteSyslogServerSection";
import { ChevronDown } from 'lucide-react';
import SyslogSettingsSection from "../../rules/syslog-settings/SyslogSettingsSection";
import PasswordComplexitySection from "./PasswordComplexitySection";

function SystemSettingsSection() {

    const history = useHistory();

    const initTableConfig = {
        selected: []
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);
    const [retentionPolicyCollapsed, setRetentionPolicyCollapsed] = useState(true);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    // Common card wrapper for settings panels
    const SettingsCard = ({ children }) => (
        <div className="card oct_analysis-card-v2 w-100 p-2">
            <div className="card-body">
                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                    {children}
                </div>
            </div>
        </div>
    );

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }} key={history.location}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-lg-6 d-flex flex-column oct_column-gap-v2">
                        {/* Left Column */}
                        <SettingsCard>
                            <ComplianceTargetSection />
                        </SettingsCard>

                        <SettingsCard>
                            <IdleTimeoutSection />
                        </SettingsCard>

                        <SettingsCard>
                            <button
                                className="oct_settings-section-header"
                                onClick={() => setRetentionPolicyCollapsed(!retentionPolicyCollapsed)}
                            >
                                <h3>Retention Policy</h3>
                                <ChevronDown className={`oct_icon oct_settings-chevron-v2 ${!retentionPolicyCollapsed ? 'oct_expanded' : ''}`} />
                            </button>
                            <div className={`oct_settings-section-body ${retentionPolicyCollapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
                                <div className="mt-4"></div>
                                <RetentionSection />
                                <div className="oct_settings-divider"></div>
                                <ValidationResultSection />
                                <div className="oct_settings-divider"></div>
                                <BackupFilesSection />
                            </div>
                        </SettingsCard>
                    </div>

                    <div className="col-12 col-lg-6 d-flex flex-column mt-4 mt-lg-0 oct_column-gap-v2">
                        {/* Right Column */}
                        {/* <SettingsCard>
                            <FetchDeviceConfigCommandSection />
                        </SettingsCard>

                        <SettingsCard>
                            <AdditionalSSHAlgorithmOptionsSection />
                        </SettingsCard> */}

                        <SettingsCard>
                            <DomainSection />
                        </SettingsCard>

                        <SettingsCard>
                            <MLConfigsSection />
                        </SettingsCard>

                        <SettingsCard>
                            <PasswordComplexitySection />
                        </SettingsCard>
                    </div>
                </div>
            </div>
            {/* <RemoteSyslogServerSection /> */}
            <SyslogSettingsSection />
        </TableContext.Provider>
    )
}

export default SystemSettingsSection;